import { render, staticRenderFns } from "./MagiclinkLogin.vue?vue&type=template&id=de930cfe"
import script from "./MagiclinkLogin.vue?vue&type=script&lang=js"
export * from "./MagiclinkLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports